export const state = () => ({
  showFirstContactModal: false,
})
export const mutations = {
  setFirstContactModal(state, payload) {
    state.showFirstContactModal = payload
  },
}
